var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ChangePasswordForm',{attrs:{"show":!!_vm.oobCode,"oobCode":_vm.oobCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }